// components/QuillCDNEditor.js
import React, { useEffect, useRef } from "react";

export default function QuillCDNEditor({ value, onChange }) {
  const editorRef = useRef(null);
  const quillInstance = useRef(null);

  useEffect(() => {
    if (editorRef.current && !quillInstance.current) {
      quillInstance.current = new window.Quill(editorRef.current, {
        theme: "snow",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
          ],
        },
      });

      // Set initial value
      quillInstance.current.root.innerHTML = value || "";

      // Listen for changes
      quillInstance.current.on("text-change", () => {
        const html = quillInstance.current.root.innerHTML;
        onChange(html);
      });
    }
  }, [value, onChange]);

  return <div ref={editorRef} style={{ minHeight: "200px" }} />;
}
